export default "__VITE_ASSET__BhodxQXS__"